import { render, staticRenderFns } from "./wait_confirmed.vue?vue&type=template&id=2123a454&scoped=true&"
import script from "./wait_confirmed.vue?vue&type=script&lang=js&"
export * from "./wait_confirmed.vue?vue&type=script&lang=js&"
import style0 from "./wait_confirmed.vue?vue&type=style&index=0&id=2123a454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123a454",
  null
  
)

export default component.exports